<template>
  <div class="btn btn-hover btn-default tw-bg-white tw-rounded-none tw-w-40 tw-text-left">
    <span v-if="dates.start">{{ dates.start.format("D [de] MMMM") }}</span>
    <span v-else class="tw-text-gray-500">Indiferente</span>
    <div class="arrow-down"></div>
  </div>
</template>

<script>
export default {
  props: ["dates"],
  data() {
    return {
      dateRangePicker: null
    };
  },
  methods: {
    updateDates(start, end) {
      this.dates.start = start;
      this.$emit("dates-updated", this.dates);
    }
  },
  mounted() {
    let self = this;
    this.dateRangePicker = $(self.$el).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        timePicker: true,
        locale: {
          cancelLabel: "Deixar em branco",
          applyLabel: "Aplicar",
          daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
        }
      },
      function(start, end) {
        self.updateDates(start, end);
        self.$emit("dates-submitted");
      }
    ).on('cancel.daterangepicker', function(e, picker) {
      self.updateDates(false, false)
      self.$emit("dates-submitted");
    })
  }
};
</script>
<style>
  .arrow-down {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 9px solid #b3b3b3;
    margin-top: 5px;
    float: right;
  }
  .calendar-time {
    display: none;
  }
</style>